import { useTranslation } from 'react-i18next';

import { getRouteApi, Link, useMatches } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';

import { useEstate } from '@/features/estates-property/api/estate';

const estateRoute = getRouteApi('/_authenticated/_sidebar-layout/estates/$estateId');

export const EstateBreadcrumb = () => {
  const { estateId } = estateRoute.useParams();
  const { data: estate } = useEstate({ id: estateId });
  const matches = useMatches();
  const { t } = useTranslation();

  if (!estate) return null;

  const estateUrl = `/_authenticated/_sidebar-layout/estates/${estateId}`;
  const isCurrent = matches[matches.length - 1].pathname === estateUrl;

  const project = estate.projects ? { id: estate.projects.id, name: estate.projects.name } : null;

  return (
    <nav className="flex items-center gap-2 text-base text-gray-500" aria-label="Breadcrumb">
      <ol className="flex items-center gap-2">
        {project?.name ? (
          <>
            <li key={`project-${project.id}`} className="flex items-center gap-2">
              <Link
                to="/projects/$projectId"
                params={{ projectId: project.id }}
                className="hover:text-gray-700"
              >
                {project.name}
              </Link>
              <ChevronRight width={16} className="text-gray-400" aria-hidden="true" />
            </li>

            <li key={`project-estates-${project.id}`} className="flex items-center gap-2">
              <Link
                to="/projects/$projectId/objects"
                params={{ projectId: project.id }}
                className="hover:text-gray-700"
              >
                {t('estates')}
              </Link>
              <ChevronRight width={16} className="text-gray-400" aria-hidden="true" />
            </li>
          </>
        ) : null}
        <li key={`estate-${estateId}`} className="flex items-center gap-2">
          <span
            className={isCurrent ? 'font-semibold text-gray-900' : 'hover:text-gray-700'}
            aria-current="page"
          >
            {estate?.name}
          </span>
        </li>
      </ol>
    </nav>
  );
};
